module.exports = __webpack_public_path__ + "static/media/sample-watertap.b948cf03.jpg";